
export function getEnv() {
  // prefer the global set in index.html, fallback to meta or window.location
  if (typeof window !== 'undefined' && window.APP_ENV) return window.APP_ENV

  var meta = document.querySelector('meta[name="app-env"]')
  if (meta && meta.content) return meta.content

  // fallback
  var host = (window.location.hostname || '').toLowerCase();
  if (host === 'localhost') return 'Engineering';

  if (host.includes('2eus2devas') || host.includes('-eng.')) return 'Engineering';
  if (host.includes('eus2devas') || host.includes('-dev.')) return 'Stage';
  if (host.includes('prod')) return 'Prod';

  return 'Prod';
}

export const isProdEnv = () => getEnv().toLowerCase() === 'prod'
export const isEngEnv = () => getEnv().toLowerCase() === 'engineering'
